import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Diagnostico } from './pages/Diagnostico';
import { useScreenInit } from './useScreenInit';
function AppContent() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-arena font-body text-carbon" data-id="element-0" data-mp="3f8ezxm85fxv9">
      <Header data-id="element-1" data-mp="2rlf74v2xls3w" />
      <main className="flex-grow" data-id="element-2" data-mp="2rit1j0zlpmob">
        <Routes data-id="element-3" data-mp="2mm2n0i3g2z50">
          <Route path="/" element={<Home data-id="element-5" data-mp="2mndqegsza4vl" />} data-id="element-4" data-mp="2mmlvl877gb6d" />
          <Route path="/diagnostico" element={<Diagnostico data-id="element-7" data-mp="31b8jhyaweb97" />} data-id="element-6" data-mp="2mjpwhgjmfggc" />
        </Routes>
      </main>
      <Footer data-id="element-8" data-mp="31c1ksjr388jy" />
    </div>;
}
export function App() {
  return <Router data-id="element-9" data-mp="2wiywor52xrb5">
      <AppContent data-id="element-10" data-mp="2wiferaffj2x4" />
    </Router>;
}